<template>
  <div class="breadcrumb-main">
    <b-breadcrumb>
      <b-breadcrumb-item :to="{ name: 'GroupDashboard' }">
        <b-icon
          icon="house"
          scale="1.25"
          shift-v="1.25"
          aria-hidden="true"
        ></b-icon>
        <span class="pl-2 home-text">Home</span>
      </b-breadcrumb-item>
      <b-breadcrumb-item
        v-for="item in items"
        :key="item.title"
        :active="item.active"
        :to="itemRoute(item)"
      >
        {{ item.title }}
      </b-breadcrumb-item>
    </b-breadcrumb>
  </div>
</template>
<script>
export default {
  name: "Breadcrumb",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  methods: {
    itemRoute(item) {
      if (!item.path || !item.path.name) return null;
      return { name: item.path.name, params: item.path.params };
    },
  },
};
</script>
<style scoped>
.breadcrumb-main{
  width: 100%;
}
.breadcrumb{
  background-color: transparent;
  padding-left: 0;
  font-size: 13px;
  padding: 0;
}
.breadcrumb-item a{
  text-decoration: none;
  color: #03C3EC ;
}
.home-text{
  color: #03C3EC ;
}
</style>
